module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g stroke=\"#979797\" stroke-linecap=\"round\" stroke-width=\"2\">\n    <path d=\"M3.625 10.117L8 14.5M12.375 10.117L8 14.5\"/>\n  </g>\n  <rect fill=\"#979797\" width=\"16\" height=\"2\" rx=\"1\"/>\n  <rect fill=\"#979797\" y=\"4\" width=\"16\" height=\"2\" rx=\"1\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/expand-list.svg
// module id = 792
// module chunks = 1